import { REGROUPEMENT } from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';

export default function isRegroupement(devisCommande, referenceId) {
  const ligneReference = devisCommande.lignesCommande.find((ligne) => {
    return referenceId === ligne.referenceRegroupement;
  });
  if (!ligneReference) return false;
  return ligneReference.typeProduit === CATEGORIE_REGROUPEMENT
    && ligneReference.type === REGROUPEMENT;
}
